<template>
<div>

    <div class="modal fade" tabindex="-1" role="dialog" id="addressModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">

                <address-form from="clinic" :address_id="modalAddressId" @addressCreated="addressCreated" @addressUpdated="addressUpdated"></address-form>
                <br clear="all">

            </div>
        </div>
    </div>

    <div class="panel panel-clinic">

        <div class="panel-heading collapsed" href="#form_address" data-toggle="collapse">
            <div class="arrow-down"></div>
            <h2 class="panel-title">Adress</h2>
        </div>

        <div id="form_address" class="panel-collapse collapse">

            <div class="panel-body">

               <div class="list-group">
                    <div class="list-group-item log-head">
                        <div class="row">
                            <div class="col-md-8">
                                Gäller från
                            </div>
                            <div class="col-md-28">
                                Adress
                            </div>
                            <div class="col-md-8">
                                Tillagd av
                            </div>
                        </div>
                    </div>

                    <div class="list-group-item log-item" :class="{ 'bold-row' : entry.address && clinic.address && entry.address.id == clinic.address.id }" v-for="entry in clinic.log_address">
                        <div class="row">
                            <div class="col-md-8">
                                {{ entry.date.substr(0, 10) }}
                            </div>
                            <div class="col-md-28" v-if="entry.address">
                                <span v-if="entry.address.co">{{ entry.address.co }},</span>
                                {{ entry.address.street }}, {{ entry.address.zip }} {{ entry.address.city }} <span style="color:#12706a; font-weight: 600; cursor:pointer; margin-left:6px;" @click="openModal(entry.address.id, entry.id)">[Redigera <img src="/images/icon-newwindow-primary.svg" style="width: 12px; margin-left:2px;"> ]</span>
                                 <div class="badge badge-primary" v-if="entry.address && clinic.address && entry.address.id == clinic.address.id">Kopplad till adress</div>
                            </div>
                            <div class="col-md-28" v-if="!entry.address">
                                Massören slutade
                            </div>
                            <div class="col-md-6">
                                {{ entry.admin.name }}
                            </div>
                            <div class="col-md-6">
                                <div class="btn btn-xs btn-info" style="float:right;" @click="edit(entry)">
                                    Ändra datum
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="btn btn-xs btn-danger" style="float:right;" @click="trash(entry)" v-if="entry.id != lastEntry.id">-
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="list-group-item log-add" :class="{ store: newEntry.id != 'new'}">

                        <div class="row" v-if="newEntry.id == 'new' && lastEntryIsToday">
                            <div class="col-md-30"><i>Du kan inte lägga en adress adress två gånger samma datum. En adress kan inte heller läggas på framtida datum.</i></div>
                        </div>

                        <div class="row" v-else>

                            <div class="col-md-8">
                                <datepicker
                                    :format="dateFormat"
                                    v-model="newEntry.date"
                                    :disabled="disabledDates"
                                    language="sv"
                                    input-class="form-control"
                                    :monday-first="true">
                                </datepicker>
                            </div>

                            <div class="col-md-28">

                                <div class="row" v-if="newEntry.id != 'new'">

                                    <div class="col-md-50" v-if="newEntry.address">
                                        <span v-if="newEntry.address.co">{{ newEntry.address.co }},</span>
                                        {{ newEntry.address.street }}, {{ newEntry.address.zip }} {{ newEntry.address.city }}
                                    </div>

                                    <div class="col-md-50" v-if="!newEntry.address">
                                        Massören slutade
                                    </div>

                                </div>

                                <div class="row" v-if="newEntry.id == 'new'">

                                    <div class="col-md-14">
                                        <select class="form-control" v-model="newEntry.type" @change="newEntry.address = null" style="width:100%;">
                                            <option value="attach">Massören börjar eller byter adress</option>
                                            <option value="detach">Massören slutar</option>
                                        </select>
                                    </div>

                                    <div class="col-md-26" v-if="newEntry.address != null">
                                         <div style="float:left; width:calc(100% - 80px); height:100%; margin-right:20px;">
                                            <span v-if="newEntry.address.co">{{ newEntry.address.co }},</span>
                                            {{ newEntry.address.street }}, {{ newEntry.address.zip }} {{ newEntry.address.city }}
                                        </div>
                                    </div>

                                    <div class="col-md-26" v-if="newEntry.type == 'attach' && !newEntry.address">

                                        <div class="input-group">
                                            <input type="text" v-model="queryInput" class="form-control" style="width: 100%;" placeholder="Har adressen använts tidigare - sök här" />
                                            <span class="input-group-addon">
                                                <transition name="loader-fade">
                                                    <i class="fa" :class="{ 'fa-cog fa-spin': queryLoading, 'fa-search': !queryLoading }" style="color: #333;" aria-hidden="true"></i>
                                                </transition>
                                            </span>
                                        </div>

                                        <div class="autocompl-result-outer" style="width:100%; margin-top:0; float:left;">

                                            <div class="autocompl-result" style="margin-left:-15px;">

                                                <div class="autocompl-row" v-for="address in queryResults">

                                                    <div style="float:left; width:calc(100% - 80px); height:100%; margin-right:20px;">
                                                        <span v-if="address.co">{{ address.co }},</span>
                                                        {{ address.street }}, {{ address.zip }} {{ address.city }}
                                                    </div>

                                                    <div style="float:left; width:50px; height:100%; overflow: hidden;">
                                                        <button class="btn btn-xs btn-info" style="width:50px;" @click="choose(address)">
                                                            Välj
                                                        </button>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>


                                    </div>

                                    <div class="col-md-10" v-if="newEntry.type == 'attach'">
                                        <div class="btn btn-info" @click="openModal('new')">Skapa adress <img src="/images/icon-newwindow-white.svg" style="width: 14px; margin-left:2px;"></div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-md-8">
                                {{ user_name }}
                            </div>

                            <div class="col-md-6">
                                <div class="btn btn-default" style="float:right;" @click="save()" v-if="newEntry.id == 'new'">
                                    Lägg till
                                </div>
                                <div class="btn btn-xs btn-default" style="float:right; margin-left:10px;" @click="save()" v-if="newEntry.id != 'new'">
                                    Spara
                                </div>
                                <div class="btn btn-xs btn-info" style="float:right;" @click="reset()" v-if="newEntry.id != 'new'">
                                    Avbryt
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

</div>
</template>


<script>

    import mixin from './mixin'

    import addressForm from '../address/form'

    export default {

        mixins: [
            mixin
        ],

        components: {
            addressForm
        },

        data ()
        {
            return {
                user_name: user_name,

                newEntry: {
                    id: 'new',
                    date: new Date(),
                    type: 'attach',
                    address: null,
                },

                dateFormat: 'yyyy-MM-dd',
                submited: false,

                queryInput: '',
                queryResults: [],
                queryLoading: false,

                modalAddressId: 'new',
                modalEntryId: '',
            }
        },

        computed: {

            hasNoEntries ()
            {
                return this.clinic.log_address.length === 0
            },

            lastEntry ()
            {
                return this.clinic.log_address[this.clinic.log_address.length - 1]
            },

            lastEntryIsToday ()
            {
                if (this.hasNoEntries) {
                    return false
                }

                return moment().isSame(this.lastEntry.date, 'day')
            },

            disabledDates ()
            {
                let to = null
                let from = moment().endOf("day").toDate()

                if (this.hasNoEntries) {
                    return  {
                        from: from
                    }
                }

                if (this.newEntry.id == 'new') {

                    this.newEntry.date = moment(this.lastEntry.date).add(1, 'days').toDate()

                    return {
                        to: moment(this.lastEntry.date).endOf("day").toDate(),
                        from: from
                    }
                }

                const currentEntryIndex = _.findIndex(this.clinic.log_address, ['id', this.newEntry.id])
                if (currentEntryIndex > 0) {
                    to = moment(this.clinic.log_address[currentEntryIndex - 1].date).endOf("day").toDate()
                }
                if (currentEntryIndex < (this.clinic.log_address.length -1)) {
                    from = moment(this.clinic.log_address[currentEntryIndex + 1].date).startOf("day").toDate()
                }

                return {
                    to: to,
                    from: from
                }
            },

        },

        created ()
        {
            this.reset()
        },

        watch: {

            queryInput ()
            {
                this.triggerSearch()
            },

        },

        methods: {

            triggerSearch ()
            {
                this.queryLoading = true;
                this.search();
            },

            search: _.debounce(function() {
                if(!this.queryInput) {
                    this.queryLoading = false;
                    this.queryResults = [];
                    return;
                }

                this.$http.post('/clinics/searchAddress', { query: this.queryInput }).then((response) => {
                    console.log(response.body);
                    this.queryResults = response.body;
                    this.queryLoading = false;
                }, (response) => {
                    console.log(JSON.stringify(response));
                });

            }, 500),

            edit (entry)
            {
                this.newEntry.id      = entry.id
                this.newEntry.date    = moment(entry.date).toDate()
                this.newEntry.address = entry.address
            },

            save ()
            {
                if (this.submited) {
                    return
                }

                this.submited = true

                let route = 'storeAddressLogEntry'
                if (this.newEntry.id != 'new') {
                    route = 'updateAddressLogEntry'
                }

                this.$http.post(
                    '/clinics/'+this.clinic.id+'/'+route,
                    {
                        log_id:  this.newEntry.id,
                        date:    this.newEntry.date,
                        address: this.newEntry.address,
                    }
                )
                .then((response) => {
                    console.log('save addresses log response')
                    console.log(response)

                    this.submited = false

                    if (this.newEntry.id == 'new') {
                        bus.$emit('notify', 'Inlägget sparades.')
                        bus.$emit('refresh-data')
                    } else {
                        bus.$emit('notify', 'Inlägget uppdaterades.')

                        this.clinic.log_address = response.data.log_address
                    }

                    this.reset()
                }, (response) => {
                    console.log(JSON.stringify(response));

                    this.submited = false
                });
            },

            trash (entry)
            {
                console.log('time to trash')
                console.log(entry)

                if (!confirm('Är du säker?')) {
                    return;
                }

                this.$http.post(
                    '/clinics/'+this.clinic.id+'/deleteAddressLogEntry',
                    {
                        log_id:  entry.id,
                    }
                )
                .then((response) => {
                    console.log('save addresses log response')
                    console.log(response)

                    this.submited = false
                    this.clinic.log_address = response.data.log_address

                    bus.$emit('notify', 'Inlägget raderades.')
                }, (response) => {
                    console.log(JSON.stringify(response))
                });
            },

            reset ()
            {
                this.newEntry.id = 'new'

                if (this.hasNoEntries) {
                    this.newEntry.date = new Date()
                } else {
                    this.newEntry.date = moment(this.lastEntry.date).add(1, 'days').toDate()
                }

                this.newEntry.type = 'attach'
                this.newEntry.address = null
            },

            typeString (type)
            {
                return type == 'active' ? 'Aktiv' : 'Inaktiv'
            },

            openModal(address_id, entry_id)
            {
                this.modalAddressId = address_id
                this.modalEntryId = entry_id

                $("#addressModal").modal('show');
            },

            addressCreated (address)
            {
                this.newEntry.address = address

                $("#addressModal").modal('hide');
            },

            addressUpdated (address)
            {
                const entryIndex = _.findIndex(this.clinic.log_address, ['id', this.modalEntryId])
                this.clinic.log_address[entryIndex].address = address

                $("#addressModal").modal('hide');
            },

            choose (address)
            {
                this.newEntry.address = address

                this.queryInput = '';
                this.queryResults = [];
            },

        }

    }

</script>
